import React from "react";
import { TextField, TextFieldProps } from "@material-ui/core";
import styled from "styled-components";
import { Tag } from '../styles/global'

interface InputWidthProps {
  $setWidth?: string | number;
}

type InputProps = TextFieldProps & {
  setWidth?: string | number;
  required?: boolean;
  requiredString?: string;
  setValue?: (value: string) => void;
  replaceCharacters?: (value: string) => string;
  isValid?: (valid: boolean) => void;
  title?: string;
};

const StyledTextField = styled(TextField) <InputWidthProps & TextFieldProps>`
  width: ${props => {
    if (!props.$setWidth) return '100%';
    return typeof props.$setWidth === 'number' ? `${props.$setWidth}px` : props.$setWidth;
  }};
` as React.ComponentType<InputWidthProps & TextFieldProps>;

export const Input: React.FC<InputProps> = ({
  setWidth,
  setValue,
  required,
  requiredString,
  replaceCharacters,
  isValid,
  title,
  ...rest
}) => {
  const isValueValid = React.useCallback((value: any): boolean => {
    return !required || (value !== undefined && value !== null && value !== "");
  }, [required]);

  React.useEffect(() => {
    if (isValid) {
      isValid(isValueValid(rest.value));
    }
  }, [rest.value, isValid, isValueValid]);

  return (
    <>
      {title && <Tag>{title}{required && ' *'}</Tag>}
      <StyledTextField
        {...rest}
        value={rest.value ?? ""}
        $setWidth={setWidth}
        error={!isValueValid(rest.value)}
        helperText={!isValueValid(rest.value) ? requiredString : ""}
        variant="outlined"
        onChange={(e) => {
          let value = e.target.value;
          if (replaceCharacters) {
            value = replaceCharacters(value);
          }
          if (setValue) setValue(value);
          if (rest.onChange) rest.onChange(e);
        }}
      />
    </>
  );
};
